import { StreakIcon, CompleteIcon, UserIcon } from "../../../../assets";
import { Card } from "../../../../components/card";
import { Column, Row } from "../../../../components/flex/styled";
import { H3, P, Span } from "../../../../components/typography/styled";
import { EmployerDashboardWrapper } from "./styled";
import { LineGraph } from "../../../../components/linegraph";
import Cookies from "universal-cookie";
import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWallet } from "@fortawesome/free-solid-svg-icons";
import { SuccessModal } from "../../../../containers/app/modals/successmodal";
import { EmployeeBulkUploadModal } from "../../../../containers/app/modals/employeebulkuploadmodal";
import { getDashboard } from "../../../../utils/apis/dashboard/getDashboard";
import { getCompanyDetails } from "../../../../utils/apis/company/getCompanyDetails";

export const EmployerDashboard = () => {
  const cookies = new Cookies();
  const TOKEN = cookies.get("TOKEN");
  const COMPANY_ID = cookies.get("COMPANY_ID");
  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);
  const [overview, setOverview] = useState({});
  const [company, setCompany] = useState({});

  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const sortedPayrollSalaries = [...(overview?.payrollSalaries || [])]
    .sort((a, b) => a.month - b.month)
    .map((item) => ({
      ...item,
      month: monthNames[item.month - 1],
    }));

  useEffect(() => {
    getDashboard(TOKEN, COMPANY_ID)
      .then((data) => setOverview(data))
      .catch((err) => {
        console.error("Failed to fetch overview:", err);
      });
  }, [TOKEN, COMPANY_ID]);

  useEffect(() => {
    getCompanyDetails(TOKEN, COMPANY_ID)
      .then((res) => setCompany(res?.data || {}))
      .catch((err) => {
        console.error("Failed to fetch company details:", err);
      });
  }, [TOKEN, COMPANY_ID]);

  const handleCloseSuccessModal = () => {
    return setIsSuccessModalOpen(false);
  };

  const handlePersistModal = () => {
    setIsSuccessModalOpen(true);
  };

  return (
    <EmployerDashboardWrapper>
      <SuccessModal
        open={isSuccessModalOpen}
        handleClickOutside={handlePersistModal}
        className={"delete-employee-success-modal"}
        title={"Success"}
        message={`Employee has been successfully added`}
        callToAction={"Close"}
        handleCallToActionClick={handleCloseSuccessModal}
      />
      <EmployeeBulkUploadModal
        width={"40%"}
        height={"350px"}
        setIsSuccessModalOpen={setIsSuccessModalOpen}
      />

      <Row className="cards-group">
        {company?.payrollPlan?.toLowerCase() === "premium" && (
          <Card className={"wallet-card"}>
            <Row
              alignitems={"center"}
              justifycontent={"space-between"}
              className="card-body-introduction"
            >
              <Column gap={"0.1rem"}>
                <P className="card-title">Credit Balance</P>
                <H3>Available Credit</H3>
              </Column>
              <FontAwesomeIcon
                icon={faWallet}
                size="2x"
                color="var(--color-primary)"
              />
            </Row>
            <div className="card-body">
              <P>
                <Span>{company?.creditBalance?.toLocaleString() ?? 0}</Span>{" "}
                Balance
              </P>
            </div>
          </Card>
        )}

        <Card className={"last-payroll-card"}>
          <Row
            alignitems={"center"}
            justifycontent={"space-between"}
            className="card-body-introduction"
          >
            <Column gap={"0.1rem"}>
              <P className="card-title">Last Payroll Ran</P>
              <H3>Run Completion</H3>
            </Column>

            <CompleteIcon alignitems={"center"} />
          </Row>

          <div className="card-body">
            <P>
              <Span>
                {"" + overview?.lastPayrollSalary?.toLocaleString() || 0}
              </Span>{" "}
              NGN{" "}
            </P>
            <Row alignitems={"center"} gap={"0.5rem"}>
              {" "}
              <UserIcon />
              <P>{overview?.lastPayrollEmployees} employees processed</P>
            </Row>
          </div>
        </Card>
        <Card className={"company-streak-card"}>
          <Row
            alignitems={"center"}
            justifycontent={"space-between"}
            className="card-body-introduction"
          >
            <Column gap={"0.1rem"}>
              <P className="card-title">Company Streak</P>
              <H3>Precision Work</H3>
            </Column>

            <StreakIcon alignitems={"center"} />
          </Row>

          <Column className="card-body">
            <ul className="card-body-list">
              <li>
                Total employees <Span>{overview?.totalEmployees}</Span>
              </li>
              <li>
                Processed Runs <Span>{overview.totalPayrollCount}</Span>{" "}
              </li>
            </ul>
          </Column>
        </Card>
      </Row>

      <LineGraph
        title={"Payment History"}
        labels={sortedPayrollSalaries.map((salary) => salary.month)}
        datasets={[
          {
            label: "Payroll Run",
            data: sortedPayrollSalaries.map((salary) => salary.value),
          },
        ]}
      />
    </EmployerDashboardWrapper>
  );
};
